function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Documents-/-sidebar-/-UI-short",
  transform: "translate(-211.000000, -43.000000)",
  fill: "#9F9AAD",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-4-Copy",
  transform: "translate(20.000000, 30.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "magnifying-glass",
  transform: "translate(191.000000, 13.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.8285714,13.0057143 L10.4628571,9.64 C11.2971429,8.62285714 11.8,7.32 11.8,5.9 C11.8,2.64285714 9.15714286,0 5.9,0 C2.64,0 0,2.64285714 0,5.9 C0,9.15714286 2.64,11.8 5.9,11.8 C7.32,11.8 8.62,11.3 9.63714286,10.4657143 L13.0028571,13.8285714 C13.2314286,14.0571429 13.6,14.0571429 13.8285714,13.8285714 C14.0571429,13.6028571 14.0571429,13.2314286 13.8285714,13.0057143 Z M5.9,10.6257143 C3.29142857,10.6257143 1.17142857,8.50571429 1.17142857,5.9 C1.17142857,3.29428571 3.29142857,1.17142857 5.9,1.17142857 C8.50571429,1.17142857 10.6285714,3.29428571 10.6285714,5.9 C10.6285714,8.50571429 8.50571429,10.6257143 5.9,10.6257143 Z",
  id: "Shape"
}))))));

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.b4f1aa69.svg";
export { ForwardRef as ReactComponent };